import qs from "querystring";
import { getLanguageFromURL } from '@/i18n/utils';

// ==================== H5端API配置 ====================
// 根据项目分支和环境切换API地址
// 盈养项目配置:
const origin = "https://v1.api.nb-s.cn"; // 盈养正式环境
// const origin = 'https://apitest.nb-s.cn/';          // 盈养测试环境

// 海王项目配置:
// const origin = 'https://apitest.nb-s.cn';             // 当前：海王测试环境 (开发阶段)
// const origin = 'https://sr.api.nb-s.cn';           // 海王正式环境 (发布时切换)

// 流式数据API配置 (AI问卷功能专用)
const Testorigin = "https://apitest.nb-s.cn"; // 流式API测试环境

// 导出测试环境基础URL
export { Testorigin };

// ==================== 语言请求头工具函数 ====================

/**
 * 获取Accept-Language请求头
 * 根据当前语言设置返回对应的请求头值
 * @returns {string} Accept-Language请求头值
 */
function getAcceptLanguageHeader() {
  const currentLanguage = getLanguageFromURL();
  
  // 根据语言设置返回对应的Accept-Language请求头
  if (currentLanguage === 'en-US') {
    return 'en-US,en;q=0.9';
  } else {
    return 'zh-CN,zh;q=0.9';
  }
}

export function post(url, params) {
  return fetch(origin + url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": getAcceptLanguageHeader(),
    },
    // body: qs.encode(params)
    body: JSON.stringify(params),
  })
    .then((res) => res.json())
    .then((res) => res.data);
}

export function get(url, params) {
  const queryString = params ? `?${qs.encode(params)}` : "";
  return fetch(origin + url + queryString, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": getAcceptLanguageHeader(),
    },
  })
    .then((res) => res.json())
    .then((res) => res.data);
}

export function getStream(url, params) {
  const queryString = params ? `?${qs.encode(params)}` : "";
  return fetch(origin + url + queryString, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": getAcceptLanguageHeader(),
    },
  }).then((res) => res);
}
export function postStream(url, formData) {
  return fetch(origin + url, {
    method: "POST",
    headers: {
      // 注意：FormData请求不设置Content-Type，让浏览器自动设置
      "Accept-Language": getAcceptLanguageHeader(),
    },
    body: formData,
  }).then((res) => res);
}

export async function postImage(url, params) {
  const response = await fetch(origin + url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": getAcceptLanguageHeader(),
    },
    body: JSON.stringify(params),
  });
  
  if (!response.ok) {
    throw new Error(`请求失败: ${response.status}`);
  }
  
  const blob = await response.blob();
  console.log('Blob信息 - 大小:', blob.size, '类型:', blob.type);
  
  const imageUrl = URL.createObjectURL(blob);
  console.log('生成的图片URL:', imageUrl);
  
  return imageUrl;
}

export async function getStreamText(url, params, abortController, queue) {
  const queryString = `?serial_number=${params.serial_number}`;
  const fullUrl = Testorigin + url + queryString;
  const options = {
    method: "GET",
    headers: { 
      "Content-Type": "application/json",
      "Accept-Language": getAcceptLanguageHeader(),
    },
    signal: abortController?.signal,
  };

  try {
    const response = await fetch(fullUrl, options);
    if (!response.ok) throw new Error(`请求失败，状态码: ${response.status}`);

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    let done = false;

    while (!done) {
      const { value, done: streamDone } = await reader.read();
      done = streamDone;

      if (value) {
        buffer += decoder.decode(value, { stream: true });
        let lines = buffer.split("\n");
        buffer = lines.pop() || "";

        for (const line of lines) {
          const trimmed = line.trim();
          if (!trimmed.startsWith("data:")) continue;
          const jsonStr = trimmed.slice(5).trim();
          try {
            const parsed = JSON.parse(jsonStr);
            queue.push(parsed); // 生产者放入队列
          } catch (e) {
            console.warn("解析数据出错:", e, "原始数据:", jsonStr);
            // 解析失败，保留到下次继续拼接
            buffer = "data:" + jsonStr;
          }
        }
      }
    }

    // 处理最后可能的数据
    if (buffer.trim()) {
      const trimmed = buffer.trim();
      if (trimmed.startsWith("data:")) {
        const jsonStr = trimmed.slice(5).trim();
        try {
          const parsed = JSON.parse(jsonStr);
          queue.push(parsed);
        } catch (e) {
          console.warn("解析最终数据出错:", e);
        }
      }
    }

    queue.close(); // 关闭队列表示数据结束
  } catch (error) {
    console.error("获取流式数据时出错:", error);
    if (queue) {
      // 如果是主动中断请求，不标记为错误
      if (error.name === "AbortError") {
        console.log("请求被用户取消");
        queue.close(); // 正常关闭队列
      } else {
        queue.setError(error); // 设置错误状态
      }
    }
    throw error;
  }
}

export async function postFormDataStream(
  url,
  formData,
  abortController,
  queue
) {
  const fullUrl = Testorigin + url;
  const options = {
    method: "POST",
    headers: {
      "Accept-Language": getAcceptLanguageHeader(),
    },
    body: formData,
    signal: abortController?.signal,
  };

  try {
    const response = await fetch(fullUrl, options);
    if (!response.ok) throw new Error(`请求失败，状态码: ${response.status}`);

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    let done = false;

    while (!done) {
      const { value, done: streamDone } = await reader.read();
      done = streamDone;

      if (value) {
        buffer += decoder.decode(value, { stream: true });
        let lines = buffer.split("\n");
        buffer = lines.pop() || "";

        for (const line of lines) {
          const trimmed = line.trim();
          if (!trimmed.startsWith("data:")) continue;
          const jsonStr = trimmed.slice(5).trim();
          try {
            const parsed = JSON.parse(jsonStr);
            queue.push(parsed); // 生产者放入队列
          } catch (e) {
            console.warn("解析数据出错:", e, "原始数据:", jsonStr);
            // 解析失败，保留到下次继续拼接
            buffer = "data:" + jsonStr;
          }
        }
      }
    }

    // 处理最后可能的数据
    if (buffer.trim()) {
      const trimmed = buffer.trim();
      if (trimmed.startsWith("data:")) {
        const jsonStr = trimmed.slice(5).trim();
        try {
          const parsed = JSON.parse(jsonStr);
          queue.push(parsed);
        } catch (e) {
          console.warn("解析最终数据出错:", e);
        }
      }
    }

    queue.close(); // 关闭队列表示数据结束
  } catch (error) {
    console.error("发送表单数据流时出错:", error);
    if (queue) {
      // 如果是主动中断请求，不标记为错误
      if (error.name === "AbortError") {
        console.log("请求被用户取消");
        queue.close(); // 正常关闭队列
      } else {
        queue.setError(error); // 设置错误状态
      }
    }
    throw error;
  }
}

// ==================== 环境配置说明 ====================
/*
H5端环境配置规则:

1. 分支管理:
   - H5也是两个分支，海王和盈养是分开的
   - 海王H5分支: 包含AI问卷功能
   - 盈养H5分支: 基础报告功能

2. API地址配置:
   盈养项目:
   - 正式环境: https://v1.api.nb-s.cn
   - 测试环境: https://apitest.nb-s.cn
   
   海王项目:
   - 正式环境: https://sr.api.nb-s.cn
   - 测试环境: https://apitest.nb-s.cn/nepstar

3. 流式数据API (AI功能专用):
   - 测试环境: https://apitest.nb-s.cn
   - 正式环境: https://sr.api.nb-s.cn

4. 部署地址:
   盈养H5: https://share.nb-s.cn/
   海王H5: https://sr.share.nb-s.cn/

注意事项:
- 发布前需要切换到对应的正式环境API
- 流式数据API用于AI问卷的语音交互功能
- 海王项目包含完整的AI问卷系统
*/
